<vb-ui-checkbox name="selectAllChkBox" [ngClass]="styles.chkBox" [(ngModel)]="isChecked" (ngModelChange)="onCheckboxChange()">
</vb-ui-checkbox>

